
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Dark Themes`}</h3>
    <p>{`We've added a dark theme for Angular and React applications. These are available starting in version 2.0.0 of our `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@pxblue/themes"
      }}>{`@pxblue/themes`}</a>{` package.`}</p>
    <h3>{`Hybrid Code Examples`}</h3>
    <p>{`We have begun building out mobile pattern examples, starting with `}<a parentName="p" {...{
        "href": "/patterns/user-auth"
      }}>{`Login`}</a>{`. You'll notice two new options in the framework selection dropdown for our supported mobile technologies.`}</p>
    <h3>{`Design Patterns`}</h3>
    <p>{`New design patterns and examples are available for `}<a parentName="p" {...{
        "href": "/patterns/forms"
      }}>{`Forms and Validation`}</a>{` and `}<a parentName="p" {...{
        "href": "/patterns/internationalization"
      }}>{`Internationalization`}</a>{`.`}</p>
    <h3>{`Ionic Support`}</h3>
    <p>{`PX Blue now offers support for developing mobile applications with `}<a parentName="p" {...{
        "href": "/development/frameworks-mobile/ionic"
      }}>{`Ionic`}</a>{`. Ionic 4+ is capable of working with the Angular Material component library and PX Blue themes for Angular. We will be phasing out support for NativeScript applications in favor of Ionic.`}</p>
    <h3>{`Component Library`}</h3>
    <p>{`Re-usable components built by the PX Blue team for use in your applications. We currently have `}<strong parentName="p">{`Hero`}</strong>{` components available for both `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/angular/?path=/info/components-hero--readme"
      }}>{`Angular`}</a>{` (version 7) and `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/react/?path=/info/components-hero--get-read-me-story"
      }}>{`React`}</a>{`.`}</p>
    <h3>{`Miscellaneous`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes and theme improvements`}</li>
      <li parentName="ul">{`New icons and updated `}<a parentName="li" {...{
          "href": "/style/iconography"
        }}>{`Iconography Page`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;